import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ModalBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import { ReactComponent as TranslateIcon } from 'assets/icon-translate.svg';

import { Button } from 'shared/components/Buttons';
import { ModalHeader } from 'shared/components/modal/ModalHeaders';

import { colors } from 'shared/defaultTheme';
import useApi from 'hooks/useApi';
import { loadAllCustomFields } from 'redux/actions/customFieldActions';

import CustomFieldForm from './CustomFieldForm';
import CustomFieldSelector from './CustomFieldSelector';
import FieldForm from './FieldForm';
import TranslateFormModal from './TranslateFormModal';
import { TranslateActionWrapper, CustomFieldWrapper, FieldFormModal } from './styles';

const CustomField = () => {
  const { t } = useTranslation();
  const { customAreaApi } = useApi();
  const dispatch = useDispatch();
  const [openFormModal, setOpenFormModal] = useState(false);
  const [selectedFieldType, setSelectedFieldType] = useState('');
  const [isNew, setIsNew] = useState(false);
  const [selectedField, setSelectedField] = useState();
  const { cusNavId } = useSelector((state) => state.auth);
  const [showTranslateModal, setShowTranslateModal] = useState(false);

  const [{ loading }, getCustomFieldData] = customAreaApi(
    {
      url: `${window.API_V1}/cus/fields/${cusNavId}`,
      method: 'GET',
    },
    { manual: true }
  );

  const bootAsync = async () => {
    try {
      const {
        data: { errors, data },
      } = await getCustomFieldData();
      if (errors.length) {
        return;
      }
      dispatch(loadAllCustomFields(data));
    } catch (error) {
      if (error.response?.status === 400) {
        dispatch(loadAllCustomFields([]));
      }
      console.error('Error getting translated custom fields: ', error);
    }
  };

  useEffect(() => {
    if (!loading) {
      bootAsync();
    }
  }, []);

  const onSelectFieldType = (currentType) => {
    setIsNew(true);
    setSelectedField(undefined);
    setSelectedFieldType(currentType);
    setOpenFormModal(true);
  };

  const updateField = (field) => {
    setIsNew(false);
    setSelectedField(field);
    setSelectedFieldType(field.type);
    setOpenFormModal(true);
  };

  const onCloseFormModal = () => {
    setOpenFormModal(false);
    setSelectedFieldType(undefined);
    setIsNew(false);
  };

  const onToggleTranslate = () => {
    setShowTranslateModal((currentValue) => !currentValue);
  };

  return (
    <>
      <TranslateActionWrapper>
        <Button
          className="translate-button"
          type="button"
          color="secondary"
          label={t('general_translate')}
          icon={<TranslateIcon />}
          onClick={onToggleTranslate}
        />
      </TranslateActionWrapper>
      <CustomFieldWrapper>
        <CustomFieldSelector onSelect={onSelectFieldType} />
        <CustomFieldForm onUpdateField={updateField} />
        <FieldFormModal isOpen={openFormModal} toggle={onCloseFormModal} size="md">
          <ModalHeader
            className="modal-header"
            backgroundColor={colors.transparent}
            onClose={onCloseFormModal}
          />
          <ModalBody>
            <FieldForm
              isNew={isNew}
              fieldFormType={selectedFieldType}
              selectedField={selectedField}
              onCancel={onCloseFormModal}
            />
          </ModalBody>
        </FieldFormModal>
      </CustomFieldWrapper>
      {showTranslateModal && (
        <TranslateFormModal onCloseModal={onToggleTranslate} bootAsync={bootAsync} />
      )}
    </>
  );
};

export default CustomField;
